import { render, staticRenderFns } from "./AddLogisticsCode.vue?vue&type=template&id=3c19fcbc&scoped=true"
import script from "./AddLogisticsCode.vue?vue&type=script&lang=js"
export * from "./AddLogisticsCode.vue?vue&type=script&lang=js"
import style0 from "./AddLogisticsCode.vue?vue&type=style&index=0&id=3c19fcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19fcbc",
  null
  
)

export default component.exports